export default function Button({ children, ...rest }) {
  const common = 'inline-flex items-center justify-center disabled:pointer-events-none disabled:cursor-not-allowed cursor-pointer focus-visible:outline-none relative w-full rounded-full py-3'
  const primary_solid = 'text-white text-base font-semibold bg-brand-primary-500 hover:bg-brand-primary-600 active:bg-brand-primary-700 border-0'
  return (
    <button className={`${primary_solid} ${common}`} {...rest}>
      {children}
    </button>
  )
}